/**
 * WalkingIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const WalkingIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M7.845 18.096q-1.894 0-2.937-1.407t-1.004-3.266V13.4l-.432-.65q-.376-.576-.972-2.12t-.596-3.647q0-2.605 1.302-4.341T6.488.904q2.12 0 3.363 1.879 1.245 1.878 1.245 4.205 0 1.354-.364 2.55-.319 1.065-.724 2.1l.176.283q.253.434.583 1.214t.329 1.582q0 1.437-.92 2.408-.921.97-2.331.97M5.28 11.432l2.642-.532a38 38 0 0 0 .639-1.816q.32-.98.32-2.114 0-1.464-.664-2.657T6.5 3.12 4.783 4.316 4.12 7.03q0 1.407.386 2.563.387 1.155.774 1.84m2.57 4.448a.96.96 0 0 0 .737-.317q.292-.315.292-.87 0-.394-.188-.84a6 6 0 0 0-.388-.775l-2.184.458q.01.971.431 1.657.42.687 1.3.687m8.304 7.216q-1.41 0-2.33-.97-.92-.971-.92-2.409 0-.8.328-1.579.33-.777.583-1.217l.176-.283q-.359-.9-.724-2.098a8.7 8.7 0 0 1-.364-2.552q0-2.327 1.245-4.205 1.244-1.88 3.363-1.879 1.98 0 3.282 1.737 1.302 1.735 1.302 4.341 0 2.095-.593 3.625-.592 1.53-.975 2.122l-.432.676v.018q.018 1.86-1.014 3.266-1.032 1.407-2.927 1.407m2.565-6.693q.375-.63.768-1.8.392-1.17.392-2.603 0-1.488-.663-2.684-.664-1.197-1.717-1.196-1.053 0-1.717 1.193-.663 1.193-.663 2.67 0 1.085.304 2.053.305.968.666 1.9zm-2.577 4.477q.88 0 1.303-.693t.434-1.663l-2.202-.416q-.2.345-.38.767-.178.422-.178.806 0 .452.28.826a.88.88 0 0 0 .743.373" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const WalkingIcon = makeIcon('WalkingIcon', WalkingIconSvg)
